const styles = {
  container: 'rounded-full md:rounded-[9px] md:max-h-[47px] border-gray md:px-2.5 md:py-3 cursor-pointer',
  infoWrapper: 'hidden md:flex items-center gap-1.5 whitespace-nowrap truncate',
  name: 'text-sm font-semibold text-black px-2',
};

export default styles;
